import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";
import { Grid, Typography } from "@material-ui/core";
import Draggable from "react-draggable";

const DraggableAnswer = (props) => {
  const {
    showDraggable,
    onDragStart,
    onDragEnd,
    onDragUpdate,
    currentQuestion,
    dragStarted,
    classes,
  } = props;

  return (
    <Grid className={classes.draggableMainContainer}>
      <Grid className={classes.draggableContainer}>
        {showDraggable && (
          <Draggable
            onDrag={onDragUpdate}
            onStart={onDragStart}
            onStop={onDragEnd}
            position={{ x: 0, y: 0 }}
            handle="#answer-icon"
          >
            <Grid
              container
              alignItems="center"
              className={classes.draggableElement}
            >
              <img
                id="answer-icon"
                src={currentQuestion.icon}
                className={`${classes.questionImg} animate__animated animate__bounceIn`}
              />
              <Grid className="animate__animated animate__bounceIn">
                <Typography className={classes.serviceTitle}>
                  {currentQuestion.title}
                </Typography>
                <Typography className={classes.serviceDesc} dangerouslySetInnerHTML={{ __html: currentQuestion.desc }}>
                </Typography>
              </Grid>
            </Grid>
          </Draggable>
        )}
      </Grid>
      {(dragStarted || !showDraggable) && (
        <Grid className={classes.iconTraceBack} />
      )}
    </Grid>
  );
};

export default withStyles(styles)(DraggableAnswer);
